import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Products() {
    const [params, setParams] = useSearchParams();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState(["Todos"]);

    const category = params.get("categoria") || "Todos";
    const search = params.get("search") || "";

    useEffect(() => {
        api.get("/categories")
            .then(({ data }) => setCategories(["Todos", ...(data.categories || [])]))
            .catch(() => setCategories(["Todos"]));
    }, []);

    useEffect(() => {
        setLoading(true);
        const q = {};
        if (category && category !== "Todos") q.category = category;
        if (search) q.search = search;
        api.get("/products", { params: q })
            .then(({ data }) => setProducts(data))
            .finally(() => setLoading(false));
    }, [category, search]);

    const setCategory = (c) => {
        const next = new URLSearchParams(params);
        if (c === "Todos") next.delete("categoria");
        else next.set("categoria", c);
        setParams(next);
    };

    const heading = useMemo(() => {
        if (search) return `Resultados para "${search}"`;
        if (category && category !== "Todos") return category;
        return "Todos los productos";
    }, [category, search]);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="products-page">
            <div className="mb-8">
                <span className="text-marigold font-semibold uppercase tracking-widest text-xs">Catálogo</span>
                <h1 className="font-display text-4xl md:text-5xl font-semibold text-cocoa mt-1">{heading}</h1>
                <p className="text-muted-foreground mt-2">{products.length} productos disponibles</p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
                {categories.map((c) => (
                    <button
                        key={c}
                        data-testid={`filter-${c}`}
                        onClick={() => setCategory(c)}
                        className={`px-4 py-2 rounded-full text-sm font-medium border transition-all ${
                            category === c
                                ? "bg-mexred text-cocoa border-mexred shadow-md"
                                : "bg-white text-cocoa border-border hover:border-mexred hover:text-cocoa"
                        }`}
                    >
                        {c}
                    </button>
                ))}
            </div>

            {loading ? (
                <div className="py-20 text-center">
                    <div className="inline-block animate-spin w-8 h-8 border-4 border-mexred border-t-transparent rounded-full" />
                </div>
            ) : products.length === 0 ? (
                <div className="py-20 text-center text-muted-foreground">
                    No hay productos en esta categoría.
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                    {products.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            )}
        </div>
    );
}
